"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mixins = require("./mixins");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ScreenReaderText = _styledComponents["default"].span.withConfig({
  displayName: "ScreenReaderText",
  componentId: "sc-n2i6in-0"
})(["", ";"], _mixins.hiddenButReaderAccessibleMixin);
var _default = ScreenReaderText;
exports["default"] = _default;